<template>
  <div>
    <header-component></header-component>
    <div class="container">
      <div class="registration-success g-py-100">
        <div class="row">
          <div class="col-lg-6 offset-lg-3 col-md-8 offset-md-2 col-sm-12 offset-sm-0 col-xs-12 offset-sm-0">
            <div class="success-div">
              <p class="heading">Congratulations!</p>
              <p class="success_msg">
                You have successfully submitted your registration form for the Changing Life through Lenses&reg; program!
              </p>
              <p class="success_msg">
                <a href="#" v-on:click="GeneratePdf()">Click here</a>
                <span v-if="isLoading">
                  <img src="../../../static/img/loading.gif" style="width: 25px"/>
                </span>
                to download a copy of the contract for your records.
              </p>
              <p class="success_msg">
                An email has been sent to the email address you provided with a link to activate your account.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footer-component></footer-component>
  </div>
</template>
<script>
import HeaderComponent from "@/components/shared/HeaderComponent";
import FooterComponent from "@/components/shared/FooterComponent";

export default {
  components: { HeaderComponent, FooterComponent },
  data() {
    return {
      isLoading: false
    };
  },
  methods: {
    GeneratePdf() {
      var _this = this;
      _this.isLoading = true;
      var salesforceId = _this.$route.query.salesforceId;
      axios
        .get("/Account/GetContractBySalesforceId/" + salesforceId, {
          headers: { Authorization: "Bearer " + localStorage.getItem("token") }
        })
        .then(function(response) {
          var result = response.data.raw;
          var link = document.createElement("a");
          link.href = result;
          link.target = "_blank";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          _this.isLoading = false;
        })
        .catch(function(error) {
          console.log(error);
          _this.$router.push({ name: "Error" });
        });
    }
  },
  created() {
    this.userRefId = sessionStorage.getItem("referralCode");
  }
};
</script>


// WEBPACK FOOTER //
// RegistrationSuccess.vue?c328efaa